import { Alert } from 'antd';

const AlertHomologMode = () => {
  return (
    <div className='flex justify-center w-full'>
      <Alert
        className='w-full'
        message="Ambiente de Teste. Esta é uma simulação de compra, nenhum valor será cobrado."
        type="warning"
        showIcon
      />
    </div>
  );
};

export default AlertHomologMode;
